import type { MarginProperties } from '@iheartjane/reefer';
import { Flex, Typography } from '@iheartjane/reefer';

import type { TileProps } from './tile';
import { Tile } from './tile';

import styles from './tileSection.module.css';

export interface TileSectionProps extends MarginProperties {
  /** Class name to apply to the container */
  className?: string;

  /** Label to render above the tiles */
  label: string;

  /** Tiles to render */
  tiles: TileProps[];
}

export const TileSection = ({
  className,
  label,
  tiles,
  ...marginProps
}: TileSectionProps) => {
  return (
    <Flex
      className={className}
      flexDirection="column"
      gap={16}
      {...marginProps}
    >
      <Typography variant="body-semibold">{label}</Typography>

      <Flex gap={16}>
        {tiles.map(({ icon, label: tileLabel }, index) => {
          return (
            <Tile
              className={styles['tile']}
              key={`${label}-${index}`}
              label={tileLabel}
              icon={icon}
            />
          );
        })}
      </Flex>
    </Flex>
  );
};
